import makeStyles from "@material-ui/core/styles/makeStyles";
import { DisbursementReasonCategory } from "generated/graphql";
import colors from "Styles/colors";

const useStyles = makeStyles(({ spacing }) => ({
  contentWrapper: {
    minWidth: 440,
  },
  topBox: {
    backgroundColor: colors.grayLight,
    borderRadius: 2,
    padding: spacing(2),
    marginBottom: spacing(2),
  },
  yourFile: {
    fontWeight: "bold",
  },
  label: {
    marginBottom: spacing(1),
  },
  terminationNotice: ({ reason }: { reason?: DisbursementReasonCategory }) => ({
    maxWidth: 450,
    fontSize: 14,
    textAlign: "center",
    visibility: reason === DisbursementReasonCategory.Termination ? "visible" : "hidden",
  }),
  cancel: {
    textDecoration: "none",
    color: colors.blue,
    "&:hover": {
      color: colors.blue,
    },
  },
}));

export default useStyles;
